import React from 'react';
import { Route } from 'react-router-dom';
import { APP_ROUTES } from '../../shared/config/routes-config';
import FurnishingManagementContainer from '../furnishingContainer';

export const FurnishingManagementModule = () => {
  return (
    <Route
      exact
      path={APP_ROUTES.FURNISHING_MANAGEMENT_MODULE.CHILDREN?.PACKAGES.FULL_PATH}
      component={FurnishingManagementContainer}
    />
  );
};
